import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

@Pipe({ name: 'crewdate' })
export class CrewDatePipe implements PipeTransform {

    constructor(private datePipe: DatePipe) {
    }

    transform(value: Date): string {
        
        if (!value) {
            return "";
        }

        return this.datePipe.transform(value, "dd-MM-yyyy");
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/shared/crew-date.pipe.ts